import Vue from 'vue'
import Vuex from 'vuex'
import {mutations} from './mutations'
import * as actions from './actions'
import { abilityPlugin, ability as appAbility } from '../abilities';

export const ability = appAbility;

Vue.use(Vuex);


const state = {
    dynassurances_web_site_url: 'http://www.dynassurances.fr',
    isLoggedIn: !!localStorage.getItem('access_token'),
    isTokenRefreshing: false,
    user: localStorage.getItem('user'),
    userInfo: {},
    quotes: {},
    locale: 'fr',
    last_token_updated: null,
    backToDevisListActive: false,
};

export const store = new Vuex.Store({
    plugins: [
        abilityPlugin
    ],
    state,
    mutations,
    actions,
    getters: {
        isLoggedIn: state => {
            return state.isLoggedIn
        },
        authUser: state => {
            return state.user
        },
        getAuthUserInfo: state => {
            return state.userInfo
        },
        isMutuaide: state => {
          let user = state.userInfo;
          return !!(user.mechanic && user.mechanic.is_mutuaide);
        },
        isGarden: state => {
          let user = state.userInfo;
          return !!(user.mechanic && user.mechanic.is_garden);
        },
        isBroker: state => {
          let user = state.userInfo;
          return !!(user.mechanic && user.mechanic.is_broker);
        },
        isDealer: state => {
            let user = state.userInfo;
            return !!(user.mechanic && user.mechanic.is_dealer);
        },
        is4097: state => {
          let user = state.userInfo;
          return !!(user.mechanic && (user.mechanic.id === 4840 || user.mechanic.id === 4845));
        },
        isSarrut: state => {
          let user = state.userInfo;
          return !!(user.mechanic && user.mechanic.representative_id === 58);
        },
        isSarrutAdmin: state => {
          let user = state.userInfo;
          return !!(user.representative && user.representative.id === 58);
        },
        isLeMondeCampingCar: state => {
          let user = state.userInfo;
          return !!(user.mechanic && user.mechanic.representative_id === 9);
        },
        isSaga: state => {
          let user = state.userInfo;
          return !!(user.mechanic && user.mechanic.representative_id === 61);
        },
        isSagaAdmin: state => {
          let user = state.userInfo;
          return !!(user.representative && user.representative.id === 61);
        },
        isRepresentative: state => {
          let user = state.userInfo;
          return !!user.representative;
        },
        getRepresentative: state => {
          let user = state.userInfo;
          return user.representative;
        },
        getMechanic: state => {
          let user = state.userInfo;
          return user.mechanic;
        },
        getDateFormat() {
          return state.locale === 'fr' ? 'DD/MM/YYYY' : 'MM/DD/YYYY' ;
      },
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js